import { createStyles, makeStyles } from '@material-ui/styles';
import { ITheme } from 'theme/types';

const useStyles = makeStyles((theme: ITheme) =>
  createStyles({
    heading: {
      paddingBottom: theme.spacing(2),
      paddingTop: theme.spacing(1),
    },
  })
);

export default useStyles;
